import * as Types from './type';

export const setUserInfo = (data: IInfoUserDataAPI) => {
  return {
    type: Types.SET_USER_INFO,
    payload: data,
  };
};
